import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateMasterActiveLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveLesson/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteMasterActiveLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveLesson/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllMasterActiveLesson extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveLesson/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateMasterActiveLesson,
  DeleteMasterActiveLesson,
  GetAllMasterActiveLesson,
};
